import { useEffect, useState } from 'react';
import ReportPeriodService from '../shared/services/report-period/report-period.service';

export function useHasOpenReportPeriod(deps: any[] = []) {
  const reportPeriodService = new ReportPeriodService();
  const [hasOpenReport, setHasOpenReport] = useState<boolean | null>(null);
  useEffect(() => {
    reportPeriodService.getAllReportPeriod(`?status=open`)
      .then(response => {
        setHasOpenReport(response.length > 0);
      })
      .catch(err => {
        console.log(err);
        setHasOpenReport(null);
      });
  }, deps);

  return hasOpenReport;
}
